<template>
  <swiper-base
    ref="swiper"
    class="swiper-type-two"
    :items="items"
    :last-item-offset="lastItemOffset"
    @change="onChange"
  >
    <template v-slot:item="{ item }">
      <slot name="item" :item="item"></slot>
    </template>

    <template v-slot:buttons>
      <u-icon-button
        v-if="hasPrevButton"
        class="swiper-type-two__button swiper-type-two__button--prev"
        icon-name="left"
        size="s"
        dark
        @click="onSwipe('end')"
      >
        prev
      </u-icon-button>
      <u-icon-button
        v-if="hasNextButton"
        class="swiper-type-two__button swiper-type-two__button--next"
        icon-name="right"
        size="s"
        dark
        @click="onSwipe('start')"
      >
        next
      </u-icon-button>
    </template>

    <template v-slot:dots>
      <swiper-pagination-dots
        class="swiper-type-two__dots"
        :total-pages="totalPages"
        :current-page-index="currentItemIndex"
        @navigate-to="onDotClick"
      />
    </template>
  </swiper-base>
</template>

<script>
import { UIconButton } from 'universkin-shared';

import SwiperBase from '@/components/common/app-swiper/SwiperBase.vue';
import SwiperPaginationDots from '@/components/common/app-swiper/SwiperPaginationDots.vue';

export default {
  name: 'SwiperTypeTwo',
  components: { SwiperBase, UIconButton, SwiperPaginationDots },
  props: {
    items: {
      type: Array,
      required: true
    }
  },
  data() {
    return { currentItemIndex: 0 };
  },
  computed: {
    hasPrevButton() {
      return this.currentItemIndex > 0;
    },
    hasNextButton() {
      return this.currentItemIndex < this.items.length - 1 - this.lastItemOffset;
    },
    lastItemOffset() {
      return window.matchMedia('(min-width: 600px)').matches ? 1 : 0;
    },
    totalPages() {
      return this.items.length - this.lastItemOffset;
    }
  },
  methods: {
    onSwipe(direction) {
      this.$refs.swiper.swipeInDirection(direction);
    },
    onChange(index) {
      this.currentItemIndex = index;
      this.$emit('change', index);
    },
    onDotClick(page) {
      this.$refs.swiper.swipeToIndex(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.swiper-type-two {
  position: relative;
  --item-width: 75%;
  --item-gap: 8px;

  &__button {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);

    &:lang(ar) {
      transform: translateY(-50%) scaleX(-1);
    }
  }

  &__button--prev:not(:lang(ar)),
  &__button--next:lang(ar) {
    left: 0;
  }

  &__button--next:not(:lang(ar)),
  &__button--prev:lang(ar) {
    right: var(--ws-grid-m, 16px);
  }

  &__dots {
    margin-top: 24px;
  }
}

@media (min-width: 480px) {
  .swiper-type-two {
    --item-width: 60%;
  }
}

@media (min-width: 600px) {
  .swiper-type-two {
    --item-width: 41%;

    &__button--prev:not(:lang(ar)),
    &__button--next:lang(ar) {
      left: 16px;
    }

    &__button--next:not(:lang(ar)),
    &__button--prev:lang(ar) {
      right: calc(var(--ws-grid-m) + 16px);
    }
  }
}

@media (min-width: 1200px) {
  .swiper-type-two {
    --item-width: calc(50% - 2px);
    --item-gap: 4px;

    &__button--next:not(:lang(ar)),
    &__button--prev:lang(ar) {
      right: calc(16px);
    }
  }
}
</style>
